<form [formGroup]="form" class="mat-typography">
    <table>
        <tr>
            <th>
                Field
            </th>

            <th>
                Current Value
            </th>

            <th>
                Desired Value
            </th>

            <th>
                Status
            </th>
        </tr>

        <tr>
            <td>
                State
            </td>

            <td>
                {{data?.state}}
            </td>

            <td>
                <mat-form-field appearance="fill">
                    <mat-label>State</mat-label>
                    <mat-select formControlName="state">
                        <mat-option [value]="'enabled'">Enabled</mat-option>
                        <mat-option [value]="'disabled'">Disabled</mat-option>
                    </mat-select>
                </mat-form-field>
            </td>

            <td>
                <sway-baseline-status [hasError]="errorsString.includes('state!')"></sway-baseline-status>
            </td>
        </tr>

        <ng-container *ngIf="form.get('state')?.value === 'enabled'">
        <tr>
            <td>
                <div class="info-wrapper">
                    Minimum Lifetime (minutes)
                    <mat-icon
                        [matTooltip]="'Minimum lifetime in minutes for a Temporary Access Pass. Defines the shortest time a TAP can be valid. Must be less than or equal to Maximum Lifetime. Range: 10-43200 minutes (30 days).'">
                        info
                    </mat-icon>
                </div>
            </td>

            <td>
                <div>{{data?.minimumLifetimeInMinutes}} minutes</div>
                <div class="text-muted small">({{convertMinutesToReadable(data?.minimumLifetimeInMinutes)}})</div>
            </td>

            <td>
                <mat-form-field appearance="fill">
                    <mat-label>Minutes</mat-label>
                    <input matInput type="number" formControlName="minimumLifetimeInMinutes" min="10" max="43200">
                    <mat-hint>Range: 10-43200 minutes (30 days), must be ≤ maximum lifetime</mat-hint>
                    <mat-error *ngIf="form.get('minimumLifetimeInMinutes')?.hasError('required')">
                        This field is required
                    </mat-error>
                    <mat-error *ngIf="form.get('minimumLifetimeInMinutes')?.hasError('min')">
                        Minimum value is 10 minutes
                    </mat-error>
                    <mat-error *ngIf="form.get('minimumLifetimeInMinutes')?.hasError('max')">
                        Maximum value is 43200 minutes
                    </mat-error>
                    <mat-error *ngIf="form.get('minimumLifetimeInMinutes')?.hasError('greaterThanMaximum')">
                        Must be less than or equal to Maximum Lifetime ({{form.get('maximumLifetimeInMinutes')?.value}} minutes)
                    </mat-error>
                </mat-form-field>
            </td>

            <td>
                <sway-baseline-status [hasError]="errorsString.includes('minimumLifetimeInMinutes')"></sway-baseline-status>
            </td>
        </tr>

        <tr>
            <td>
                <div class="info-wrapper">
                    Maximum Lifetime (minutes)
                    <mat-icon
                        [matTooltip]="'Maximum lifetime in minutes for a Temporary Access Pass. Defines the longest time a TAP can be valid. Must be greater than or equal to Minimum Lifetime. Range: 10-43200 minutes (30 days).'">
                        info
                    </mat-icon>
                </div>
            </td>

            <td>
                <div>{{data?.maximumLifetimeInMinutes}} minutes</div>
                <div class="text-muted small">({{convertMinutesToReadable(data?.maximumLifetimeInMinutes)}})</div>
            </td>

            <td>
                <mat-form-field appearance="fill">
                    <mat-label>Minutes</mat-label>
                    <input matInput type="number" formControlName="maximumLifetimeInMinutes" min="10" max="43200">
                    <mat-hint>Range: 10-43200 minutes (30 days), must be ≥ minimum lifetime</mat-hint>
                    <mat-error *ngIf="form.get('maximumLifetimeInMinutes')?.hasError('required')">
                        This field is required
                    </mat-error>
                    <mat-error *ngIf="form.get('maximumLifetimeInMinutes')?.hasError('min')">
                        Minimum value is 10 minutes
                    </mat-error>
                    <mat-error *ngIf="form.get('maximumLifetimeInMinutes')?.hasError('max')">
                        Maximum value is 43200 minutes
                    </mat-error>
                    <mat-error *ngIf="form.get('maximumLifetimeInMinutes')?.hasError('lessThanMinimum')">
                        Must be greater than or equal to Minimum Lifetime ({{form.get('minimumLifetimeInMinutes')?.value}} minutes)
                    </mat-error>
                </mat-form-field>
            </td>

            <td>
                <sway-baseline-status [hasError]="errorsString.includes('maximumLifetimeInMinutes')"></sway-baseline-status>
            </td>
        </tr>

        <tr>
            <td>
                <div class="info-wrapper">
                    Default Lifetime (minutes)
                    <mat-icon
                        [matTooltip]="'Default lifetime in minutes when creating a Temporary Access Pass. This value is used when no specific lifetime is specified. Must be between Minimum Lifetime and Maximum Lifetime. Range: 10-43200 minutes (30 days).'">
                        info
                    </mat-icon>
                </div>
            </td>

            <td>
                <div>{{data?.defaultLifetimeInMinutes}} minutes</div>
                <div class="text-muted small">({{convertMinutesToReadable(data?.defaultLifetimeInMinutes)}})</div>
            </td>

            <td>
                <mat-form-field appearance="fill">
                    <mat-label>Minutes</mat-label>
                    <input matInput type="number" formControlName="defaultLifetimeInMinutes" min="10" max="43200">
                    <mat-hint>Range: 10-43200 minutes (30 days), must be between minimum and maximum</mat-hint>
                    <mat-error *ngIf="form.get('defaultLifetimeInMinutes')?.hasError('required')">
                        This field is required
                    </mat-error>
                    <mat-error *ngIf="form.get('defaultLifetimeInMinutes')?.hasError('min')">
                        Minimum value is 10 minutes
                    </mat-error>
                    <mat-error *ngIf="form.get('defaultLifetimeInMinutes')?.hasError('max')">
                        Maximum value is 43200 minutes
                    </mat-error>
                    <mat-error *ngIf="form.get('defaultLifetimeInMinutes')?.hasError('belowMinimum')">
                        Must be greater than or equal to Minimum Lifetime ({{form.get('minimumLifetimeInMinutes')?.value}} minutes)
                    </mat-error>
                    <mat-error *ngIf="form.get('defaultLifetimeInMinutes')?.hasError('aboveMaximum')">
                        Must be less than or equal to Maximum Lifetime ({{form.get('maximumLifetimeInMinutes')?.value}} minutes)
                    </mat-error>
                </mat-form-field>
            </td>

            <td>
                <sway-baseline-status [hasError]="errorsString.includes('defaultLifetimeInMinutes')"></sway-baseline-status>
            </td>
        </tr>

        <tr>
            <td>
                <div class="info-wrapper">
                    Length (characters)
                    <mat-icon
                        [matTooltip]="'Default number of characters for a Temporary Access Pass. Range: 8-48.'">
                        info
                    </mat-icon>
                </div>
            </td>

            <td>
                {{data?.defaultLength}}
            </td>

            <td>
                <mat-form-field appearance="fill">
                    <mat-label>Characters</mat-label>
                    <input matInput type="number" formControlName="defaultLength" min="8" max="48">
                    <mat-hint>Range: 8-48 characters</mat-hint>
                    <mat-error *ngIf="form.get('defaultLength')?.hasError('required')">
                        This field is required
                    </mat-error>
                    <mat-error *ngIf="form.get('defaultLength')?.hasError('min')">
                        Minimum value is 8 characters
                    </mat-error>
                    <mat-error *ngIf="form.get('defaultLength')?.hasError('max')">
                        Maximum value is 48 characters
                    </mat-error>
                </mat-form-field>
            </td>

            <td>
                <sway-baseline-status [hasError]="errorsString.includes('defaultLength')"></sway-baseline-status>
            </td>
        </tr>

        <tr>
            <td>
                <div class="info-wrapper">
                    Single-Use Only
                    <mat-icon
                        [matTooltip]="'If enabled, the Temporary Access Pass can only be used once. If disabled, it can be used multiple times within its lifetime.'">
                        info
                    </mat-icon>
                </div>
            </td>

            <td>
                {{data?.isUsableOnce ? 'Yes' : 'No'}}
            </td>

            <td>
                <mat-form-field appearance="fill">
                    <mat-label>Require Single Use</mat-label>
                    <mat-select formControlName="isUsableOnce">
                        <mat-option [value]="true">Yes</mat-option>
                        <mat-option [value]="false">No</mat-option>
                    </mat-select>
                </mat-form-field>
            </td>

            <td>
                <sway-baseline-status [hasError]="errorsString.includes('isUsableOnce')"></sway-baseline-status>
            </td>
        </tr>
        </ng-container>
    </table>

    <div class="mt-4" *ngIf="form.get('state')?.value === 'enabled'">
        <app-authentication-method-policy-targets
            [readOnly]="readOnly"
            [groups]="groups$ | async" [tenantId]="tenant_id" [form]="form"
            [policy]="data" [item]="baselineTemplateItem"
            [errorsString]="errorsString"></app-authentication-method-policy-targets>
    </div>
</form>
